import { createContext } from 'react'
import type { Session, User } from '@supabase/supabase-js'
import type { Organization, OrganizationRole } from '@/types/database'

export interface Membership {
  organization: Organization
  role: OrganizationRole
}

export interface AuthContextValue {
  session: Session | null
  user: User | null
  memberships: Membership[]
  /** True until the stored session has been restored on first load. */
  loading: boolean
  error: string | null
  signIn: (email: string, password: string) => Promise<void>
  signOut: () => Promise<void>
  refreshMemberships: () => Promise<void>
}

/**
 * Lives in its own module so AuthProvider.tsx exports only a component, which
 * is what keeps Fast Refresh working during development.
 */
export const AuthContext = createContext<AuthContextValue | null>(null)
